import React, { Fragment } from "react";

import { notDiseaseFund } from "../../helpers/fund";

const OtherHelp = ({ data }) => {
  return (
    <Fragment>
      <p className="f-h3">Find Other Help</p>

      {/* Show transportation resources if this is the transportation fund */}
      {notDiseaseFund(data.Fund_ID) && (
        <Fragment>
          <p className="u-mt1 u-mb2">
            Visit our directory to look for transportation assistance from other
            organizations
          </p>
          <a href="/transportation-directory" className="btn">
            Transportation resources
          </a>
        </Fragment>
      )}

      {/* Show Fund Finder for other funds */}
      {!notDiseaseFund(data.Fund_ID) && (
        <Fragment>
          <p className="u-mt1 u-mb2">
            Sign up for{" "}
            <a className="f-link" href="https://fundfinder.panfoundation.org/">
              FundFinder
            </a>{" "}
            to find open funds from other organizations.
          </p>
          <a href="https://fundfinder.panfoundation.org/" className="btn">
            FundFinder
          </a>
        </Fragment>
      )}
    </Fragment>
  );
};

export default OtherHelp;
